import { Card, CardHeader, Skeleton, Stack, Typography } from "@mui/material";
import React from "react";
import { parseHTML } from "screens/Tickets/ViewTicket/Components/CommentEditor";
import { isTruthy } from "helpers/methods";
import Attachments from "screens/Tickets/ViewTicket/Components/Attachments";

interface CustomProps {
  ticketDetails: any;
  isLoading: boolean;
}

const TicketReporterDetails = (props: CustomProps) => {
  return (
    <Card sx={{ p: "24px" }}>
      <CardHeader title="Description" color="#000000" sx={{ p: 0.5 }} />
      <Stack direction="column" spacing={1}>
        {props.isLoading ? (
          <Skeleton animation="wave" variant="text" height={25} width={100} />
        ) : (
          <Typography color="#6C737F" variant="body1">
            {isTruthy(props?.ticketDetails?.description) &&
              parseHTML(props?.ticketDetails?.description)}
          </Typography>
        )}
      </Stack>
      {props.ticketDetails?.docUrls.length > 0 && props.isLoading ? (
        <Skeleton animation="pulse" variant="rectangular" height={25} width={100} />
      ) : (
        <Attachments
          ticketDetails={props.ticketDetails}
          isLoading={props.isLoading}
        />
      )}
    </Card>
  );
};

export default TicketReporterDetails;
